import React from "react";
import { Reveal, RevealGroup, RevealItem } from "@/components/site/Reveal";
import { PlatformIcon } from "@/components/site/PlatformIcon";
import { STREAMING, SOCIAL } from "@/data/platforms";

const Tile = ({ item, url }) => {
  const disabled = !url;
  const inner = (
    <>
      <PlatformIcon name={item.name} iconName={item.icon} size={26} className="transition-transform group-hover:scale-110" />
      <span className="font-caps mt-3" style={{ fontSize: ".56rem", color: disabled ? "var(--ash)" : "var(--parchment)" }}>{item.name}</span>
      {disabled && <span className="font-caps mt-1" style={{ fontSize: ".48rem", color: "var(--ash)" }}>Coming soon</span>}
    </>
  );
  const base = "group flex flex-col items-center justify-center text-center px-3 py-6 h-full transition-colors";
  const style = { border: "var(--rule)", borderRadius: "var(--radius)", color: "var(--parchment)", backgroundColor: "transparent" };
  if (disabled) return <div className={base} style={{ ...style, opacity: 0.55 }} data-testid={`platform-tile-${item.name}`}>{inner}</div>;
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className={`${base} hover:border-[var(--gold)]`} style={style}
       onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--ink-raised)")}
       onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
       data-testid={`platform-tile-${item.name}`}>
      {inner}<span className="sr-only">(opens in a new tab)</span>
    </a>
  );
};

const Group = ({ title, items, urls }) => (
  <div className="mt-12">
    <p className="font-caps text-ash mb-5" style={{ fontSize: ".6rem" }}>{title}</p>
    <RevealGroup className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4" stagger={0.03}>
      {items.map((item) => (
        <RevealItem key={item.name + title}><Tile item={item} url={(urls || {})[item.name]} /></RevealItem>
      ))}
    </RevealGroup>
  </div>
);

export const ListenEverywhere = ({ links = {} }) => {
  return (
    <section id="platforms" className="section-pad" style={{ backgroundColor: "var(--ink-raised)" }} data-testid="platforms-section">
      <div className="mx-auto max-w-[1360px] px-5 sm:px-8">
        <Reveal>
          <p className="font-caps text-gold" style={{ fontSize: ".72rem" }}>One Artist</p>
          <h2 className="font-display foil-text mt-3" style={{ fontSize: "var(--t-h2)", lineHeight: 1.05 }}>Every platform</h2>
          <p className="mt-4 max-w-xl" style={{ color: "var(--ash)" }}>Stream, save and follow P. Frazy wherever you listen. Links light up as each platform goes live.</p>
        </Reveal>

        <Group title="Streaming & Stores" items={STREAMING} urls={links.streaming} />
        <Group title="Social & Video" items={SOCIAL} urls={links.social} />
      </div>
    </section>
  );
};
